if (!customElements.get('home-banner-slider')) {
  class HomeBannerSlider extends HTMLElement {
    constructor() {
      super();
      this.slides = [];
      this.dots = [];
      this.currentIndex = 0;
      this.timer = null;
      this.touchStartX = null;
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.rg-home-banner__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-slide-to]'));

      if (this.slides.length < 2) return;

      this.showSlide(this.currentIndex);

      this.querySelector('.rg-home-banner-slider__button--previous')?.addEventListener('click', () => {
        this.showSlide(this.currentIndex - 1);
        this.restartTimer();
      });
      this.querySelector('.rg-home-banner-slider__button--next')?.addEventListener('click', () => {
        this.showSlide(this.currentIndex + 1);
        this.restartTimer();
      });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.showSlide(Number(dot.dataset.slideTo));
          this.restartTimer();
        });
      });

      this.addEventListener('mouseenter', () => this.stopTimer());
      this.addEventListener('mouseleave', () => this.startTimer());
      this.addEventListener('focusin', () => this.stopTimer());
      this.addEventListener('focusout', () => this.startTimer());
      this.addEventListener('touchstart', (event) => {
        this.touchStartX = event.changedTouches[0]?.clientX ?? null;
        this.stopTimer();
      }, { passive: true });
      this.addEventListener('touchend', (event) => {
        const touchEndX = event.changedTouches[0]?.clientX;
        if (this.touchStartX !== null && touchEndX !== undefined) {
          const distance = touchEndX - this.touchStartX;
          if (Math.abs(distance) > 45) this.showSlide(this.currentIndex + (distance < 0 ? 1 : -1));
        }
        this.touchStartX = null;
        this.startTimer();
      }, { passive: true });

      this.startTimer();
    }

    disconnectedCallback() {
      this.stopTimer();
    }

    showSlide(index) {
      const direction = index > this.currentIndex ? 1 : index < this.currentIndex ? -1 : 0;
      const nextIndex = (index + this.slides.length) % this.slides.length;
      const previousIndex = (nextIndex - 1 + this.slides.length) % this.slides.length;
      const followingIndex = (nextIndex + 1) % this.slides.length;
      const repositionIndex = direction > 0 ? followingIndex : direction < 0 ? previousIndex : -1;
      const repositionSlide = repositionIndex >= 0 ? this.slides[repositionIndex] : null;

      // 3枚構成では、反対側のスライドが左右を横切って見えてしまう。
      // その1枚だけを一度隠して反対側へ即時配置し、次のフレームで再表示する。
      repositionSlide?.classList.add('is-repositioning');

      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === nextIndex;
        slide.classList.toggle('is-active', active);
        slide.classList.toggle('is-previous', slideIndex === previousIndex && !active);
        slide.classList.toggle('is-next', slideIndex === followingIndex && !active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === nextIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });

      if (repositionSlide) {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => repositionSlide.classList.remove('is-repositioning'));
        });
      }

      this.currentIndex = nextIndex;
    }

    startTimer() {
      if (
        this.dataset.autoRotate !== 'true' ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
        this.timer
      ) return;

      const delay = Number(this.dataset.changeSpeed) || 6000;
      this.timer = window.setInterval(() => this.showSlide(this.currentIndex + 1), delay);
    }

    stopTimer() {
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restartTimer() {
      this.stopTimer();
      this.startTimer();
    }
  }

  customElements.define('home-banner-slider', HomeBannerSlider);
}
